<template>
  <div>
    <Forgot></Forgot>
  </div>
</template>
<script>
import Forgot from "@/components/Forgot.vue";
export default {
  components: { Forgot },
  data() {
    return {};
  },
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/pages/forgot/Forgot.vue